// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBlockInfoLabel_root__Db9r_","infoLabelCustomButton":"HeaderBlockInfoLabel_infoLabelCustomButton__bexCa"};